import React, { useRef } from 'react'
import { CourseVerticalCard } from 'components/ui/CourseCards'
import { Slider } from 'components/ui/Slider'
import { useAccess } from 'contexts/AccessContext'
import { useIsMobile } from 'hooks/useIsMobile'
import useSlidesToShow from 'hooks/useSlidesToShow'
import styles from './CoursesCarousel.module.scss'

interface ICarousel {
  data: any[]
}

export const Carousel: React.FC<ICarousel> = ({ data }) => {
  const swiping = useRef(false)
  const { isAdmin } = useAccess()
  const isMobile = useIsMobile()
  const sliderContainerRef = useRef<HTMLDivElement>(null)

  const slidesToShow = useSlidesToShow({
    containerRef: sliderContainerRef,
  })

  return (
    <div ref={sliderContainerRef} className={styles.sliderContainer}>
      <Slider
        afterChange={() => {
          swiping.current = false
        }}
        beforeChange={() => {
          swiping.current = true
        }}
        dots={false}
        slidesToScroll={1}
        centerMode={false}
        variableWidth
        arrows={!isMobile && data.length > slidesToShow}
        infinite={data.length > slidesToShow}
        swipe={data.length > slidesToShow}
      >
        {data.map((course) => (
          <div key={course.id}>
            {/* Is necessary to wrap the card with a div to avoid a bug with the margin */}
            <div
              style={{
                marginRight: '24px',
              }}
            >
              <CourseVerticalCard
                course={course.course}
                enrol={course.enrol}
                enrolled={!isAdmin()}
                swiping={() => swiping.current}
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  )
}
